import { FC } from 'react';
import { Trans, useTranslation } from '@frontend/i18n';
import { Text, TextLink } from '@frontend/design-system';

const INSURANCE_VERIFICATION_HELP_CENTER_URL = 'https://www.weavehelp.com/hc/en-us/articles/4410657422363';

export const InsuranceVerificationSignedUpContent: FC = () => {
  const { t } = useTranslation('subscription', { keyPrefix: 'wiv' });
  return (
    <Text size='large'>
      <Trans t={t}>
        To learn more about Weave Insurance Verification click{' '}
        <TextLink target='_blank' href={INSURANCE_VERIFICATION_HELP_CENTER_URL} rel='noopener noreferrer'>
          here
        </TextLink>
        .
      </Trans>
    </Text>
  );
};
